import React from 'react';
import { Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../../util/translationUtility';
const plus = <i className="expand-button collapsed"/>;
const minus = <i className="expand-button" />;
const showMoreThreshold = 4;

class Facet extends React.Component {
    componentWillMount() {
        this.setState({ expanded: true });
    }

    render() {
        const {
            name,
            displayName,
            values,
            onAttributeChange,
            expanded,
            onToggleFacetExpanded,
            updateOnToggle,
            showMore,
            onToggleShowMore,
            disableToggle
        } = this.props;
        const symbol = disableToggle ? null
            : expanded ? minus : plus;
        const sizeToShow = showMore
            ? values.length
            : Math.min(showMoreThreshold, values.length);
        const showShowMore = !showMore && values.length > showMoreThreshold;
        const Count = ({ number }) => <sup className="count">({number})</sup>
        return (
            <div className="facet">
                <div className="facet-header" onClick={() => disableToggle ? false : onToggleFacetExpanded(name)}>
                    <span className="body-text text-md">
                        {displayName}
                    </span>
                    {symbol}
                </div>
                <Collapse isOpen={expanded || disableToggle}>
                    <div className="facet-values">

                        {values.slice(0, sizeToShow).map((value, k) => {
                            const key = `${name}-${k}`;
                            const checkedCss = value.Checked ? 'bold' : 'normal';
                            return (
                                <div key={key} className="d-flex facet-value pl-1" style={{ fontWeight: checkedCss}}>
                                    <input id={key} name={key} type="checkbox" checked={value.Checked} onChange={() => {
                                        // value.Checked = !value.Checked;
                                        onAttributeChange(name, value.Name);
                                    }}
                                    />
                                    <label htmlFor={key}>{value.DisplayName}</label>
                                </div>
                            )
                        })
                        }
                        {showShowMore && <a className="show-more toggle-show-more-button" style={{ display: 'block', marginTop: '10px', marginBottom: '10px' }} onClick={() => onToggleShowMore(name)}>{translateResourceString("/SearchApp/Attributes/ShowMore")}</a>}
                    </div>

                </Collapse>
            </div>
        );
    }
}

Facet.propTypes = {
    name: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    values: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        Checked: PropTypes.bool,
        Count: PropTypes.number
    })).isRequired,
    onAttributeChange: PropTypes.func,
    expanded: PropTypes.bool,
    onToggleFacetExpanded: PropTypes.func,
    updateOnToggle: PropTypes.bool,
    showMore: PropTypes.bool,
    onToggleShowMore: PropTypes.func,
};

export default Facet;
